module.exports = "/_next/static/images/colocationDataCenters-45128e00e772f70333c7b614f6c6daa4.webp";